module.exports = __webpack_public_path__ + "static/media/reports-gray.a2f56e2d.png";